import React from 'react';
import { MappedItems } from '../../../../../../../shared/lib/functional';
import { getTimeOptions } from '../../../../../../../shared/lib/reserve';
import { BareEventHost } from '../../../../../../../shared/types/reservable';
import { TimeOption } from '../../../../../../../shared/types/reserve';
import { ReserveCacheSlot } from '../../../../../../../shared/types/reserveCache';
import Button from './Button';

interface TimePickerProps {
  selectedTime?: TimeOption;
  onSelectedTime: (time: TimeOption) => void;
  timeslots: ReserveCacheSlot[];
  hosts?: MappedItems<BareEventHost>;
}

export function TimePicker(props: TimePickerProps) {
  const { timeslots, selectedTime, onSelectedTime, hosts } = props;

  const { options } = getTimeOptions(timeslots, hosts);

  if (options.length === 0) {
    return <div className="text-center text-muted">No available times for this date.</div>;
  }

  return (
    <div className="flex flex-wrap gap-4">
      {options.map(opt => {
        const isSelected = selectedTime?.key === opt.key;

        return (
          <Button
            key={opt.key}
            variant={isSelected ? 'accent' : 'borderlike'}
            aria-label={`Select time ${opt.timeLabel}${opt.hostLabel ? ` with ${opt.hostLabel}` : ''}`}
            onClick={() => {
              if (!isSelected) onSelectedTime(opt);
            }}
            className={isSelected ? 'no-disabled' : ''}
          >
            <div className="grid grid-cols-1 gap-1 text-left">
              <div className="flex flex-wrap items-center">
                <div className="text-left mr-6 flex-grow grid grid-cols-1 gap-1">
                  {opt.label && (
                    <div
                      className={`${isSelected ? 'text-white' : 'text-accent'} font-bold text-sm`}
                    >
                      {opt.label}
                    </div>
                  )}
                  <div
                    className={`
                      ${isSelected ? 'text-white' : opt.label ? 'text-secondary' : 'text-accent'} ${opt.label ? `text-xs ` : `text-sm font-bold`}
                    `}
                  >
                    {opt.timeLabel}
                  </div>
                </div>
                <div className={`${isSelected ? 'text-white' : 'text-secondary'} text-sm`}>
                  {opt.spotsLeft} slots
                </div>
              </div>
              {opt.hostLabel && (
                <div className={`${isSelected ? 'text-white' : 'text-secondary'} text-sm`}>
                  {opt.hostLabel}
                </div>
              )}
            </div>
          </Button>
        );
      })}
    </div>
  );
}
